module.exports = __webpack_public_path__ + "static/media/inbound_icon-focused.2443511c.svg";